import React from "react";

export const Button = ({
  children,
  className,
  type = "button",
  background = "#0039EC",
  textColor = "white",
  border,
  onClick,
  newButtonClassName,
  width,
  height,
  padding,
  disabled,
  fontSize = "20px",
}) => {
  return (
    <button
      onClick={onClick}
      className={
        newButtonClassName
          ? newButtonClassName
          : `btn py-2 px-3 fs18  ${className}`
      }
      type={type}
      disabled={disabled}
      style={{
        background: background,
        color: textColor,
        border: border,
        width: width,
        height: height,
        fontWeight: "500",
        fontSize: fontSize,
        lineHeight: "24px",
        padding: padding,
      }}
    >
      {children}
    </button>
  );
};
